import { render, staticRenderFns } from "./StandingAwayTable.vue?vue&type=template&id=4ebc3484&scoped=true&"
import script from "./StandingAwayTable.vue?vue&type=script&lang=js&"
export * from "./StandingAwayTable.vue?vue&type=script&lang=js&"
import style0 from "./StandingAwayTable.vue?vue&type=style&index=0&id=4ebc3484&prod&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ebc3484",
  null
  
)

export default component.exports